import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

export function ForbiddenPage() {
  return (
    <Box textAlign="center" mt={10}>
      <Typography variant="h2" fontWeight={700}>
        403
      </Typography>
      <Typography variant="h6" color="text.secondary" mb={3}>
        You don't have permission to access this page.
      </Typography>
      <Button component={RouterLink} to="/dashboard" variant="contained">
        Go to Dashboard
      </Button>
    </Box>
  );
}

export default ForbiddenPage;
